export default function noop() {}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-geo/src/noop.js
// module id = RyZB
// module chunks = 0